import { useState, useEffect } from 'react';
import { Switch } from '@/components/ui/switch';
import { Field, FieldDescription } from '@/components/ui/field';
import { useTranslation } from 'react-i18next';

export const FORM_SUBSIDIARY_RIGHTS_ID = 'form-subsidiary-rights';

export default function FormSubsidiaryRights({ subsidiary, onSubmit }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        allowTokenPurchase: true,
    });

    useEffect(() => {
        if (subsidiary) {
            setFormData({
                allowTokenPurchase: subsidiary.allowTokenPurchase ?? subsidiary.allow_token_purchase ?? true,
            });
        }
    }, [subsidiary]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form id={FORM_SUBSIDIARY_RIGHTS_ID} onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5">
            <div className="space-y-5">
                <div className="bg-muted rounded-2xl p-5">
                    <Field orientation="horizontal" className="justify-between">
                        <div className="flex-1 mr-4">
                            <h3 className="text-[15px] text-foreground font-medium mb-1">
                                {t('subsidiary:autoriserLAchatDeJetons')}
                            </h3>
                            <FieldDescription className="text-[13px] text-muted-foreground">
                                {t('subsidiary:permettreACetteEntrepriseDAcheterDesJetons')}
                            </FieldDescription>
                        </div>
                        <Switch
                            checked={formData.allowTokenPurchase}
                            onCheckedChange={(checked) =>
                                setFormData((prev) => ({ ...prev, allowTokenPurchase: checked }))
                            }
                        />
                    </Field>
                </div>
            </div>
        </form>
    );
}
